import React, {useEffect, useRef, useState} from 'react';
import styled from "styled-components";
import {Container, Row, Col, Form} from "react-bootstrap";
import reactHtmlParser from "react-html-parser";
import Modal from "react-bootstrap/Modal";
import {Img} from "../Img";
import {ImageParallax} from "../ParallaxImage";
import {useForm} from "react-hook-form";
import {black, text, white} from "../../styles/globalStyleVars";

import Button from "../Button";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import {postForm} from "../../api/redux/home";
import {ImgP} from "../ImgP";



const MyComponent = ({imgSrc, upperTitle, subTitle, desc}) => {

    const [winWidth, setWinWidth] = useState(true)

    useEffect(() => {
        if (window.innerWidth > 767) {
            setWinWidth(true)
        } else {
            setWinWidth(false)
        }
        window.addEventListener("resize", () => {
            if (window.innerWidth > 767) {
                setWinWidth(true)
            } else {
                setWinWidth(false)
            }
        });
    }, [])

    const [modalOpen, setModalOpen] = useState(false); // Added state for modal
// modal
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
        setModalOpen(false); // Set modal state to closed when modal is closed
        document.documentElement.classList.remove('modal-open'); // Remove class
    };

    const handleShow = () => {
        setShow(true);
        setModalOpen(true); // Set modal state to open when modal is shown
        document.documentElement.classList.add('modal-open'); // Add class
    };


    useEffect(() => {
        if (modalOpen) {
            document.documentElement.style.overflowY = 'hidden';
        } else {
            document.documentElement.style.overflowY = 'scroll';
        }

        return () => {
            // Cleanup: reset the style when the component unmounts
            document.documentElement.style.overflowY = 'scroll';
        };
    }, [modalOpen]);



    const dispatch = useDispatch();
    const responseData = useSelector(state => state.contact);

    const {register, handleSubmit ,formState,reset} = useForm({mode: 'all'});

    //--- form submit
    const success = (msg) => toast.success(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });

    const error = (msg) => toast.error(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });
    const onSubmit = (e) => {

        let api_services = apiEndPoints.CONTACT_FORM;

        var formData = new FormData();
        formData.append('your-name', e?.name);
        formData.append('your-email', e?.email);
        formData.append('your-phone', e?.phone);
        formData.append('your-message', e?.message);

        if (e.email !== '' && e.name !== '' && e.phone !== '' && e?.message!='') {
            dispatch(postForm([api_services, formData]));
            success('Successfully Submitted')
            reset();
        }
    };
    let count=0;
    const onError = (errors) => {
        Object.values(errors).forEach((error) => {
            count++;
        });
        if(count>0){
            toast.error('please fill out the correct inputs');
        }
        count=0;
    };
    useEffect(() => {
        if (responseData && responseData?.error !== '') {
            error(responseData?.error)
        }
        if (responseData && responseData?.success !== '') {
            // success(responseData?.success)
        }

    }, [responseData])

    return (
        <>
            <StyledComponent  className='sustainability-text parallax'>
                {
                    window?.innerWidth>767 ?
                        <ImgP src={imgSrc ? imgSrc : 'images/static/blur.jpg'}/>

                        :
                        <Img src={imgSrc ? imgSrc : 'images/static/blur.jpg'}/>
                }
                <Container>
                    <Row>
                        <Col sm={12}>
                            {upperTitle && <p className={'split-up'}>{reactHtmlParser(upperTitle)}</p>}
                        </Col>

                        <Col md={6}>
                            {subTitle && <h3 className={'split-up'}>{reactHtmlParser('Still on the fence? Uncover the innovative opportunities fit for your future.')}</h3>}
                        </Col>

                        <Col md={{span:5, offset:1}}>
                            {desc && <p className={'split-up'} >{reactHtmlParser(desc)}</p>}
                            <div onClick={() => handleShow(0)}>
                                <Button width={'fit-content'} text={'Get in Touch'} color={`${white}`} border={`1px solid ${text}`} icon/>                            {/*<Button margin={'60px 0 0 0'} color={`${white}`} background={'transparent'}*/}
                            </div>

                        </Col>
                    </Row>
                </Container>
            </StyledComponent>
            <Modal className={'get-touched'} show={show} onHide={handleClose}>
                <div className="slide-form">
                    <h4>Get in Touch Today!</h4>
                    <Form onSubmit={handleSubmit(onSubmit,onError)}>
                        <Form.Group>

                            <Form.Control
                                className={formState?.errors?.name?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                {...register("name",{
                                    required: 'Username is required',
                                })}
                                type="text"
                                placeholder="Name*"/>
                        </Form.Group>

                        <Form.Group>
                            <Form.Control
                                className={formState?.errors?.email?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                {...register("email",{
                                    required:{
                                        value:true,
                                        message:'please enter your email'
                                    },
                                    pattern:{
                                        value:/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message:'please enter a valid email address'
                                    }
                                })}
                                type="email"
                                placeholder="Email*"/>
                        </Form.Group>

                        <Form.Group>
                            <Form.Control
                                className={formState?.errors?.phone?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                {...register("phone",{
                                    required:{
                                        value:true,
                                        message:'please enter your phone first'
                                    },
                                    pattern:{
                                        value:/^01[0-9]{9}$/,
                                        message:'please enter a valid 11 digit phone number'
                                    }
                                })}
                                type="number"
                                placeholder="Phone Number*"/>
                        </Form.Group>

                        <Form.Group>
                            <Form.Control
                                className={formState?.errors?.message?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                {...register("message",{
                                    required:{
                                        value:true,
                                        message:'please enter your email'
                                    },

                                })}
                                type="textarea"
                                placeholder="Message (Optional)"/>
                        </Form.Group>

                        <div className="close-btn hover" onClick={handleClose}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="10.829" height="10.828"
                                 viewBox="0 0 10.829 10.828">
                                <g id="Group_20272" data-name="Group 20272" transform="translate(-3166.586 -119.586)">
                                    <g id="Group_18979" data-name="Group 18979" transform="translate(1 -1.5)">
                                        <line id="Line_4" data-name="Line 4" x2="8" y2="8"
                                              transform="translate(3167 122.5)"
                                              fill="none" stroke="#3b3838" stroke-linecap="round" stroke-width="2"/>
                                        <line id="Line_3877" data-name="Line 3877" x1="8" y2="8"
                                              transform="translate(3167 122.5)" fill="none" stroke="#3b3838"
                                              stroke-linecap="round" stroke-width="2"/>
                                    </g>
                                </g>
                            </svg>

                        </div>
                        <div  onClick={handleSubmit(onSubmit,onError)}>
                            <Button width={'fit-content'} text={'Submit Message'} color={`${white}`} border={`1px solid ${text}`} />                            {/*<Button margin={'60px 0 0 0'} color={`${white}`} background={'transparent'}*/}
                            {/*        border={`1px solid ${white}`}*/}
                            {/*        text={'Submit Message'}/>*/}
                        </div>

                    </Form>
                </div>
            </Modal>
        </>
    );
};

const StyledComponent = styled.section`
  position: relative;  
  //padding-top: calc(828/1366 *100%) ;
  height: calc(90vh + 100px);
  
  .dc-btn{
    svg{
      line{
        stroke: ${white};
      }
    }
  }
  
  .container {
    position: absolute;
    bottom: 120px;
    left: 0;
    right: 0;
  }
  
  @media(max-width: 767px){
    height: calc(100vh + 100px);

    .container {
      position: absolute;
      top: 120px;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  p {
    color: #FFFFFF;
    margin: 0 0 40px 0;
  }

  .upper-title {
    width: 50%;
    margin: 0 0 20px 0;
  }
  
  h3 {
    color: ${white};
  }

  @media (max-width: 767px) {
    .upper-title {
      width: 100%;
    }

    h3 {
      margin: 0 0 80px 0;
    }
  }
  
`;

export default MyComponent;
